import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react'
import { getCurrentAppData } from './utils/fractalApps'

import './i18n'
import App from './app'
import configureStore from './store/configureStore'

import './index.css'

const { persistor, store } = configureStore()

const onBeforeLift = () => {
  // take some action before the gate lifts
}

const appData = getCurrentAppData()
const primaryColor = appData?.theme?.primaryColor || '#878787'
const secondaryColor = appData?.theme?.secondaryColor || '#878787'

const appTheme = {
  primaryColor,
  secondaryColor,
  ...(appData?.theme || {})
}

const muiTheme = createTheme({
  palette: {
    primary: {
      main: primaryColor
    },
    secondary: {
      main: secondaryColor
    },
    text: {
      primary: '#464646'
    }
  }
})

const container = document.getElementById('app')
const root = createRoot(container)

root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      onBeforeLift={onBeforeLift}
      persistor={persistor}
    >
      <MuiThemeProvider theme={muiTheme}>
        <EmotionThemeProvider theme={appTheme}>
          <App />
        </EmotionThemeProvider>
      </MuiThemeProvider>
    </PersistGate>
  </Provider>
)
